<template>
  <div class="relative select-none mb-sm">
    <textarea
      :value="value"
      :aria-label="ariaLabel"
      @input="$emit('input', $event.target.value)"
      @focus="focusToggled"
      @blur="blurred"
      :placeholder="placeholderText"
      :class="[{ 'tw-border-error': hasError}, inputClasses ]"
      class="w-full resize-y text-16 font-body p-5 leading-6 border-solid shadow-none outline-none py-base hover:border-placeholderGray focus:placeholder-transparent border-1 border-border rounded-6 focus:border-primary bg-whiteOverride"
      data-test="input"
      :id="id"
    />
    <label
      v-show="showLabel"
      class="absolute text-10 top-2 left-5 text-primary"
      data-test="label"
      :for="id"
    >
      {{ placeholderText }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'FloatingLabelTextArea',
  props: {
    id: {
      type: String,
      required: true,
    },
    fieldIsRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
    },
    hasError: {
      type: Boolean,
    },
    ariaLabel: {
      type: String,
      required: false,
    },
    inputClasses: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    showLabel() {
      return !!(this.hasFocus || this.value);
    },
    placeholderText() {
      return this.fieldIsRequired ? `${this.placeholder} *` : this.placeholder;
    },
  },
  methods: {
    focusToggled() {
      this.hasFocus = !this.hasFocus;
    },
    blurred(event) {
      this.hasFocus = false;
      this.$emit('blur', event.target.value);
    },
  },
};
</script>
